<!-- eslint-disable no-unused-vars -->
/* eslint-disable no-unused-vars */

<script>
import { required } from "vuelidate/lib/validators";
import _ from "lodash";

import Label from "./form-components/Label.vue";

import CKEditorVue from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "ckeditor5-build-classic-with-font";

import Multiselect from "vue-multiselect";

import HR from "./form-components/HR.vue";
import gutter from "./form-components/gutter.vue";
import BannersPreview from "./form-components/BannersPreview.vue";

export default {
  name: "BannerForm",
  components: {
    Label,
    HR,
    gutter,
    BannersPreview,
    ckeditor: CKEditorVue.component,
    Multiselect,
  },
  props: {
    form: { type: Object, required: true },
    data: { type: Object, required: true },
    variant: { type: String, default: "patch" },
    rules: { type: Object, default: () => ({}) },
    topbarControls: { type: Object },
    selectedItem: { type: Object }, // This prop might contain bannerType: 'editable'
    setSelectedItems: { type: Function },
    updateSelectedItem: { type: Function },
  },
  data() {
    return {
      submitted: false,
      formData: {},
      last_updated: {},
      textInputInternalStates: {}, // Will store { isThemedDirty, currentThemeContent }
      ckEditorInternalStates: {}, // Will store { isThemedDirty, currentThemeContent }
      selectInputInternalStates: {},
      headingInternalStates: {},
      editor: ClassicEditor,
      select_templateData: {
        "Template A": {
          purpose: "test",
          description: "description",
        },
      },
    };
  },
  computed: {
    fieldCharacterLimits() {
      const limits = {};
      if (this.additionalProp1) {
        if (this.additionalProp1.titleLimit)
          limits.title = this.additionalProp1.titleLimit;
        if (this.additionalProp1.headingLimit)
          limits.heading = this.additionalProp1.headingLimit;
        if (this.additionalProp1.paragraphLimit)
          limits.description = this.additionalProp1.paragraphLimit;
        if (this.additionalProp1.ButtonLimit)
          limits.button_label = this.additionalProp1.ButtonLimit;
        if (this.additionalProp1.linkLimit) {
          limits.link_label = this.additionalProp1.linkLimit;
          limits.link_url = this.additionalProp1.linkLimit;
        }
        // Add more mappings if needed
      }
      return limits;
    },
    isEditable() {
      return this.additionalProp1?.isEditable === true;
    },
    additionalProp1() {
      // Ensure selectedItem and additionalProp1 exist before trying to access properties
      return this.selectedItem && this.selectedItem.additionalProp1
        ? this.selectedItem.additionalProp1
        : null;
    },
    formObject() {
      let { form } = this;
      return form;
    },
    livePreviewData() {
      // Clone the selectedItem and update its fields with the latest formData values
      const base = this.selectedItem ? _.cloneDeep(this.selectedItem) : {};
      const additional = base.additionalProp1 || {};

      // Assign live formData into appropriate places
      base.title = this.formData.title || base.title;
      base.heading = this.formData.heading || base.heading;
      base.description = this.formData.description || base.description;

      additional.button_label =
        this.formData.button_label || additional.button_label;
      additional.button_link =
        this.formData.button_link || additional.button_link;
      additional.link_label = this.formData.link_label || additional.link_label;
      additional.link_url = this.formData.link_url || additional.link_url;
      additional.description =
        this.formData.description || additional.description;
      additional.heading = this.formData.heading || additional.heading;
      additional.title = this.formData.title || additional.title;
      additional.theme = this.formData.theme || additional.theme;

      base.additionalProp1 = additional;
      return base;
    },
  },

  watch: {
    data: {
      handler: function (newData) {
        this.formData = _.cloneDeep(newData);
        if (this.formObject) {
          for (const key of Object.keys(this.formObject)) {
            if (!(key in this.formData)) {
              this.$set(
                this.formData,
                key,
                this.formObject[key].default || null
              );
            }
            const itemConfig = this.formObject[key];
            if (itemConfig?.type === "text") {
              this.initializeTextInputState(key, itemConfig);
            } else if (itemConfig?.type === "ckeditor") {
              this.initializeCKEditorState(key, itemConfig);
            } else if (itemConfig?.type === "select") {
              this.initializeSelectInputState(key, itemConfig);
            } else if (itemConfig?.type === "heading") {
              this.initializeHeadingState(key, itemConfig);
            }
          }
        }
        this.applyFormRules(this.formData, this.rules);
      },
      deep: true,
      immediate: true,
    },
    last_updated: {
      handler() {
        if (!this.formObject || !this.last_updated.key) return;

        const changedKey = this.last_updated.key;
        const changedValue = this.last_updated.value;
        const changedItemConfig = this.formObject[changedKey];

        // Handle theme switching behavior
        if (changedItemConfig && changedItemConfig.isThemeSelector) {
          const newThemeName = changedValue;
          for (const [fieldKey, fieldConfig] of Object.entries(
            this.formObject
          )) {
            if (fieldConfig.isThemed && fieldConfig.themeContent) {
              const newContentForField =
                fieldConfig.themeContent[newThemeName] ||
                fieldConfig.default ||
                "";

              // Update the field's value in formData if it's different
              // This also triggers the necessary reactivity for BannersPreview
              if (this.formData[fieldKey] !== newContentForField) {
                this.$set(this.formData, fieldKey, newContentForField);
                // We directly set formData here to avoid re-triggering last_updated for the *same* theme change logic.
                // If updateValue was called, it would set last_updated again.
              }

              // Update internal state for this themed field
              const stateObject =
                fieldConfig.type === "ckeditor"
                  ? this.ckEditorInternalStates
                  : this.textInputInternalStates;
              if (stateObject) {
                if (!stateObject[fieldKey])
                  this.$set(stateObject, fieldKey, {});
                this.$set(stateObject[fieldKey], "isThemedDirty", false);
                this.$set(
                  stateObject[fieldKey],
                  "currentThemeContent",
                  newContentForField
                );
              }
            }
          }
        }

        // Standard update for display states (excluding the theme field itself if it just changed)
        for (const key in this.formObject) {
          if (
            key === changedKey &&
            changedItemConfig &&
            changedItemConfig.isThemeSelector
          ) {
            // If the changed key was the theme selector, its own display state doesn't need re-evaluation based on itself.
            // Other fields' display states might depend on the theme, and those are handled by the loop below.
          }

          const itemConfig = this.formObject[key];
          if (itemConfig?.type === "text") {
            this.updateTextInputDisplayStates(key, itemConfig);
          } else if (itemConfig?.type === "ckeditor") {
            this.updateCKEditorDisplayStates(key, itemConfig);
          } else if (itemConfig?.type === "select") {
            this.updateSelectInputDisplayStates(key, itemConfig);
          } else if (itemConfig?.type === "heading") {
            this.updateHeadingDisplayStates(key, itemConfig);
          }
        }
      },
      deep: true,
    },
    selectedItem: {
      handler() {
        if (this.formObject) {
          for (const key in this.formObject) {
            const itemConfig = this.formObject[key];
            if (itemConfig?.type === "text") {
              this.updateTextInputDisplayStates(key, itemConfig);
            } else if (itemConfig?.type === "ckeditor") {
              this.updateCKEditorDisplayStates(key, itemConfig);
            } else if (itemConfig?.type === "select") {
              this.updateSelectInputDisplayStates(key, itemConfig);
            } else if (itemConfig?.type === "heading") {
              this.updateHeadingDisplayStates(key, itemConfig);
            }
          }
        }
      },
      deep: true,
    },
  },
  validations() {
    let validations = { formData: {} };
    if (!this.formObject || Object.keys(this.formObject).length === 0) {
      return validations;
    }
    for (const [key, value] of Object.entries(this.formObject)) {
      if (
        value &&
        value.type !== "heading" &&
        value.type !== "hr" &&
        value.type !== "gutter" &&
        value.type !== "bannersPreview"
      ) {
        if (value.required) {
          validations.formData[key] = { required };
        } else {
          validations.formData[key] = {};
        }
      }
    }
    return validations;
  },
  methods: {
    handleSave(save) {
      console.log("save", save);
    },
    isContainFormLayout(obj) {
      for (let key in obj)
        if (
          Object.prototype.hasOwnProperty.call(obj, key) &&
          key.startsWith("layout_")
        )
          return true;
      return false;
    },
    getFirstLayoutOrProperty(obj) {
      for (let key in obj)
        if (
          Object.prototype.hasOwnProperty.call(obj, key) &&
          key.startsWith("layout_")
        )
          return obj[key];
      const keys = Object.keys(obj);
      return keys.length > 0 ? obj[keys[0]] : {};
    },
    displayLogic(itemConfig) {
      const contextItem = this.selectedItem || this.formData;
      if (itemConfig.type === "heading") {
        return true;
      }
      if (
        itemConfig.displayOn &&
        typeof itemConfig.displayOnValue !== "undefined"
      ) {
        if (typeof contextItem[itemConfig.displayOn] !== "undefined") {
          let valueToCheck = contextItem[itemConfig.displayOn];
          if (typeof valueToCheck === "object" && valueToCheck !== null) {
            return (
              valueToCheck.name === itemConfig.displayOnValue ||
              JSON.stringify(valueToCheck) === itemConfig.displayOnValue
            );
          }
          return String(valueToCheck) === String(itemConfig.displayOnValue);
        } else {
          return false;
        }
      }
      return true;
    },
    updateValue(key, val) {
      this.last_updated = { key, value: val }; // This will trigger the last_updated watcher
      this.$set(this.formData, key, val);

      if (this.selectInputInternalStates[key]) {
        // For select inputs, if they also need special handling
        this.$set(this.selectInputInternalStates[key], "value", val);
      }
      if (typeof this.updateSelectedItem === "function")
        this.updateSelectedItem(_.cloneDeep(this.formData));
      this.applyFormRules(this.formData, this.rules);
    },
    handleInput(key, value) {
      // First, update the main formData and trigger last_updated
      this.updateValue(key, value);

      // Then, handle themed field specific logic
      const itemConfig = this.formObject[key];
      if (itemConfig && itemConfig.isThemed) {
        const stateObject =
          itemConfig.type === "ckeditor"
            ? this.ckEditorInternalStates
            : this.textInputInternalStates;
        if (stateObject) {
          if (!stateObject[key]) this.$set(stateObject, key, {});
          this.$set(stateObject[key], "isThemedDirty", true);
          // currentThemeContent is set by theme switch, not by direct input
        }
      }
    },
    applyFormRules(currentFormData, formRules) {
      if (
        currentFormData &&
        formRules?.condition &&
        currentFormData[formRules.condition.key] === formRules.condition.value
      ) {
        formRules.actions.forEach((action) => {
          if (action.actionType === "CHANGE_VALUE") {
            this.$nextTick(() => {
              this.$set(currentFormData, action.targetKey, action.newValue);
              if (typeof this.updateSelectedItem === "function")
                this.updateSelectedItem(_.cloneDeep(currentFormData));
            });
          }
        });
      }
    },
    formSubmit() {
      console.log("formsubmit called", this.$v.formData.$invalid);
      this.submitted = true;
      // this.$v.formData.$touch();
      // if (this.$v.formData.$invalid) {
      //   console.log("BannerForm validation failed.", this.$v.formData);
      //   for (const key in this.$v.formData) {
      //     if (this.$v.formData[key] && this.$v.formData[key].$error) {
      //       console.log(
      //         `Validation error for ${key}:`,
      //         this.$v.formData[key].$params,
      //         this.formObject[key]?.label || key
      //       );
      //     }
      //   }
      //   return;
      // }
      if (this.topbarControls) {
        switch (this.variant) {
          case "add":
            if (typeof this.topbarControls.onAddFn === "function")
              this.topbarControls.onAddFn(_.cloneDeep(this.formData));
            break;
          case "patch":
            if (this.isValidationPassed()) {
              if (typeof this.topbarControls.onSubmitFn === "function")
                this.topbarControls.onSubmitFn(
                  _.cloneDeep(this.formData),
                  this.formObject
                );
            }
            break;
        }
      } else {
        this.$emit("form-submitted", {
          variant: this.variant,
          data: _.cloneDeep(this.formData),
        });
      }
    },
    isValidationPassed() {
      return true;
    },
    _evaluateCondition(currentValue, conditionValue) {
      if (currentValue === undefined) return false;
      if (typeof currentValue == "object" && currentValue !== null) {
        try {
          const parsedCondition = JSON.parse(conditionValue);
          return (
            _.isEqual(currentValue, parsedCondition) ||
            currentValue.name == conditionValue
          );
        } catch (e) {
          return currentValue.name == conditionValue;
        }
      } else if (typeof currentValue != "string") {
        return String(currentValue) == conditionValue;
      } else {
        return currentValue == conditionValue;
      }
    },

    initializeTextInputState(key, itemConfig) {
      if (!this.textInputInternalStates[key])
        this.$set(this.textInputInternalStates, key, {});

      if (itemConfig.isThemed && itemConfig.themeContent) {
        const themeFieldKey =
          Object.keys(this.formObject).find(
            (k) => this.formObject[k].isThemeSelector === true
          ) || "theme"; // Default to 'theme'
        const currentTheme =
          this.formData[themeFieldKey] || itemConfig.options?.[0]; // Use current theme or first option
        const initialContent =
          itemConfig.themeContent[currentTheme] ||
          this.formData[key] ||
          itemConfig.default ||
          "";
        this.$set(
          this.textInputInternalStates[key],
          "currentThemeContent",
          initialContent
        );
        this.$set(
          this.textInputInternalStates[key],
          "isThemedDirty",
          (this.formData[key] || "") !== initialContent && !!this.formData[key]
        );
        if (this.formData[key] === undefined || this.formData[key] === null) {
          // Set initial form data if not present
          this.$set(this.formData, key, initialContent);
        }
      }
      this.updateTextInputDisplayStates(key, itemConfig);
    },
    updateTextInputDisplayStates(itemKey, itemConfig) {
      const state = this.textInputInternalStates[itemKey] || {};
      const context = this.selectedItem || this.formData;
      const checkAndUpdate = (
        displayOnField,
        displayOnValueField,
        stateField
      ) => {
        let isMet = true;
        if (
          itemConfig[displayOnField] &&
          typeof itemConfig[displayOnValueField] !== "undefined"
        ) {
          isMet = false;
          const relevantValue =
            this.last_updated &&
            this.last_updated.key === itemConfig[displayOnField]
              ? this.last_updated.value
              : context[itemConfig[displayOnField]];
          if (typeof relevantValue !== "undefined")
            isMet = this._evaluateCondition(
              relevantValue,
              itemConfig[displayOnValueField]
            );
        }
        this.$set(state, stateField, isMet);
      };
      checkAndUpdate("displayOn", "displayOnValue", "d_check_met");
      checkAndUpdate("displayOn2", "displayOnValue2", "d_check2_met");
      checkAndUpdate("displayOn3", "displayOnValue3", "d_check3_met");
      let isDisabledByDisableOn = false;
      if (itemConfig.disableOn) {
        const relevantValue =
          this.last_updated && this.last_updated.key === itemConfig.disableOn
            ? this.last_updated.value
            : context[itemConfig.disableOn];
        isDisabledByDisableOn = !relevantValue;
      }
      this.$set(state, "is_disabled_by_specific_rule", isDisabledByDisableOn);
      if (!this.textInputInternalStates[itemKey])
        this.$set(this.textInputInternalStates, itemKey, state); // Ensure state is set if initialized first time
    },
    shouldHideTextInput(itemKey, itemConfig) {
      const state = this.textInputInternalStates[itemKey];
      if (!state || itemConfig.apply_new_rule) return false;
      if (
        itemConfig.displayOn &&
        typeof itemConfig.displayOnValue !== "undefined" &&
        !state.d_check_met
      )
        return true;
      if (
        itemConfig.displayOn2 &&
        typeof itemConfig.displayOnValue2 !== "undefined" &&
        !state.d_check2_met
      )
        return true;
      if (
        itemConfig.displayOn3 &&
        typeof itemConfig.displayOnValue3 !== "undefined" &&
        !state.d_check3_met
      )
        return true;
      return false;
    },
    isTextInputDisabled(itemKey, itemConfig) {
      const state = this.textInputInternalStates[itemKey];
      const context = this.selectedItem || this.formData;
      if (this.$route?.params?.categoryName === "globalupdate") return false;
      if (itemConfig.disableOn && state?.is_disabled_by_specific_rule)
        return true;
      if (context?.additionalProp1?.global) return true;
      return !!itemConfig.disabled;
    },
    getTextInputMaxCharCount(itemKey, itemConfig) {
      // Prefer fieldCharacterLimits if available, otherwise fallback to existing logic
      if (this.fieldCharacterLimits[itemKey]) {
        return this.fieldCharacterLimits[itemKey];
      }
      // Existing fallback logic
      const context = this.selectedItem || this.formData;
      const maxCountConfig = { "Online Consultation - Accurx": { title: 25 } };
      if (context?.title && this.$route?.params?.categoryName === "banners") {
        if (
          maxCountConfig[context.title] &&
          maxCountConfig[context.title][itemKey]
        )
          return Number(maxCountConfig[context.title][itemKey]);
      }
      return itemConfig.character_count > 0
        ? Number(itemConfig.character_count)
        : 10000;
    },

    initializeCKEditorState(key, itemConfig) {
      if (!this.ckEditorInternalStates[key])
        this.$set(this.ckEditorInternalStates, key, {});

      if (itemConfig.isThemed && itemConfig.themeContent) {
        const themeFieldKey =
          Object.keys(this.formObject).find(
            (k) => this.formObject[k].isThemeSelector === true
          ) || "theme";
        const currentTheme =
          this.formData[themeFieldKey] || itemConfig.options?.[0];
        const initialContent =
          itemConfig.themeContent[currentTheme] ||
          this.formData[key] ||
          itemConfig.default ||
          "";
        this.$set(
          this.ckEditorInternalStates[key],
          "currentThemeContent",
          initialContent
        );
        this.$set(
          this.ckEditorInternalStates[key],
          "isThemedDirty",
          (this.formData[key] || "") !== initialContent && !!this.formData[key]
        );
        if (this.formData[key] === undefined || this.formData[key] === null) {
          this.$set(this.formData, key, initialContent);
        }
      }
      this.updateCKEditorDisplayStates(key, itemConfig);
    },
    updateCKEditorDisplayStates(itemKey, itemConfig) {
      const state = this.ckEditorInternalStates[itemKey] || {};
      const context = this.selectedItem || this.formData;
      const checkAndUpdate = (
        displayOnField,
        displayOnValueField,
        stateField
      ) => {
        let isMet = true;
        if (
          itemConfig[displayOnField] &&
          typeof itemConfig[displayOnValueField] !== "undefined"
        ) {
          isMet = false;
          const relevantValue =
            this.last_updated &&
            this.last_updated.key === itemConfig[displayOnField]
              ? this.last_updated.value
              : context[itemConfig[displayOnField]];
          if (typeof relevantValue !== "undefined")
            isMet = this._evaluateCondition(
              relevantValue,
              itemConfig[displayOnValueField]
            );
        }
        this.$set(state, stateField, isMet);
      };
      checkAndUpdate("displayOn", "displayOnValue", "d_check_met");
      checkAndUpdate("displayOn2", "displayOnValue2", "d_check2_met");
      let isDisabledByDisableOn = false;
      if (itemConfig.disableOn) {
        const relevantValue =
          this.last_updated && this.last_updated.key === itemConfig.disableOn
            ? this.last_updated.value
            : context[itemConfig.disableOn];
        isDisabledByDisableOn = !relevantValue;
      }
      this.$set(state, "is_disabled_by_specific_rule", isDisabledByDisableOn);
      if (!this.ckEditorInternalStates[itemKey])
        this.$set(this.ckEditorInternalStates, itemKey, state);
    },
    shouldHideCKEditor(itemKey, itemConfig) {
      const state = this.ckEditorInternalStates[itemKey];
      if (!state) return false;
      if (
        itemConfig.displayOn &&
        typeof itemConfig.displayOnValue !== "undefined" &&
        !state.d_check_met
      )
        return true;
      if (
        itemConfig.displayOn2 &&
        typeof itemConfig.displayOnValue2 !== "undefined" &&
        !state.d_check2_met
      )
        return true;
      return false;
    },
    isCKEditorDisabled(itemKey, itemConfig) {
      const state = this.ckEditorInternalStates[itemKey];
      const context = this.selectedItem || this.formData;
      if (this.$route?.params?.categoryName === "globalupdate") return false;
      if (context?.additionalProp1?.global) return true;
      if (itemConfig.disableOn && state?.is_disabled_by_specific_rule)
        return true;
      return !!itemConfig.disabled;
    },
    getCKEditorConfig(_itemKey, itemConfig) {
      return (
        itemConfig.editorConfig || {
          toolbar: [
            "heading",
            "|",
            "fontColor",
            "|",
            "bold",
            "link",
            "bulletedList",
            "numberedList",
            "blockQuote",
            "insertTable",
            "undo",
            "redo",
          ],
          heading: {
            options: [
              {
                model: "paragraph",
                title: "Paragraph",
                class: "ck-heading_paragraph",
              },
              {
                model: "heading1",
                view: "h1",
                title: "Heading 1",
                class: "ck-heading_heading1",
              },
              {
                model: "heading2",
                view: "h2",
                title: "Heading 2",
                class: "ck-heading_heading2",
              },
              {
                model: "heading3",
                view: "h3",
                title: "Heading 3",
                class: "ck-heading_heading3",
              },
              {
                model: "heading4",
                view: "h4",
                title: "Heading 4",
                class: "ck-heading_heading4",
              },
            ],
          },
          table: {
            contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"],
          },
          fontColor: {
            colors: [
              { color: "#005EB8", label: "Blue" },
              { color: "#FF2E2E", label: "Red" },
              { color: "#4F535B", label: "Main Grey" },
            ],
          },
          link: {
            decorators: {
              toggleDownloadable: {
                mode: "manual",
                label: "Downloadable",
                attributes: { download: "file" },
              },
              openInNewTab: {
                mode: "manual",
                label: "Open in a new tab",
                attributes: { target: "_blank", rel: "noopener noreferrer" },
              },
            },
          },
        }
      );
    },

    initializeSelectInputState(key, itemConfig) {
      if (!this.selectInputInternalStates[key]) {
        this.$set(this.selectInputInternalStates, key, {
          value: this.formData[key] || itemConfig.default || null,
          d_check_met: true,
          d_check2_met: true,
        });
      }
      if (typeof this.formData[key] === "undefined") {
        this.$set(
          this.formData,
          key,
          this.selectInputInternalStates[key].value
        );
      }
      this.updateSelectInputDisplayStates(key, itemConfig);
    },
    updateSelectInputDisplayStates(itemKey, itemConfig) {
      if (!this.selectInputInternalStates[itemKey]) {
        this.$set(this.selectInputInternalStates, itemKey, {});
      }
      const state = this.selectInputInternalStates[itemKey];
      const context = this.selectedItem || this.formData;
      const checkAndUpdate = (
        displayOnField,
        displayOnValueField,
        stateField
      ) => {
        let isMet = true;
        if (
          itemConfig[displayOnField] &&
          typeof itemConfig[displayOnValueField] !== "undefined"
        ) {
          isMet = false;
          const relevantValue =
            this.last_updated &&
            this.last_updated.key === itemConfig[displayOnField]
              ? this.last_updated.value
              : context[itemConfig[displayOnField]];
          if (typeof relevantValue !== "undefined") {
            isMet = this._evaluateCondition(
              relevantValue,
              itemConfig[displayOnValueField]
            );
          }
        }
        this.$set(state, stateField, isMet);
      };
      checkAndUpdate("displayOn", "displayOnValue", "d_check_met");
      checkAndUpdate("displayOn2", "displayOnValue2", "d_check2_met");
    },
    shouldHideSelect(itemKey, itemConfig) {
      const state = this.selectInputInternalStates[itemKey];
      if (!state) return false;
      if (
        itemConfig.displayOn &&
        typeof itemConfig.displayOnValue !== "undefined" &&
        !state.d_check_met
      )
        return true;
      if (
        itemConfig.displayOn2 &&
        typeof itemConfig.displayOnValue2 !== "undefined" &&
        !state.d_check2_met
      )
        return true;
      return false;
    },
    shouldShowSelectBasedOnBanners() {
      if (this.$route?.params?.categoryName === "banners") {
        const currentSelectedItem = this.selectedItem || this.formData;
        return !!(
          currentSelectedItem?.additionalProp1?.mobile_dark ||
          currentSelectedItem?.additionalProp1?.mobile_light ||
          currentSelectedItem?.additionalProp1?.mobile_preview
        );
      }
      return true;
    },
    isSelectDisabled(itemKey, itemConfig) {
      console.log("itemKey", itemKey);
      const context = this.selectedItem || this.formData;
      if (this.$route?.params?.categoryName === "globalupdate") return false;
      if (context?.additionalProp1?.global) return true;
      if (itemConfig.disabled) return true;
      return false;
    },
    getSelectTemplatePurpose(itemKey, _itemConfig) {
      const currentValue = this.formData[itemKey];
      const categoryName = this.$route?.params?.categoryName;
      if (categoryName === "prescriptions") {
        /* ... */
      } else if (categoryName === "feedback") {
        /* ... */
      } else if (categoryName === "carerinformation") {
        /* ... */
      } else if (categoryName === "cancelappointments") {
        /* ... */
      }
      return "";
    },
    getSelectTemplateDescription(itemKey, _itemConfig) {
      const currentValue = this.formData[itemKey];
      const categoryName = this.$route?.params?.categoryName;
      if (categoryName === "prescriptions") {
        /* ... */
      } else if (categoryName === "feedback") {
        /* ... */
      } else if (categoryName === "carerinformation") {
        /* ... */
      } else if (categoryName === "cancelappointments") {
        /* ... */
      }
      return "";
    },
    showSelectTemplateDetails(itemKey, _itemConfig) {
      const categoryName = this.$route?.params?.categoryName;
      const currentSelectedItem = this.selectedItem || this.formData;
      if (
        categoryName === "feedback" &&
        itemKey === "option_template" &&
        (currentSelectedItem.title === "Concerns / Complaints" ||
          currentSelectedItem.title === "Complaints")
      )
        return true;
      else if (
        categoryName === "prescriptions" &&
        itemKey === "template" &&
        currentSelectedItem.title === "Webform"
      )
        return true;
      else if (
        categoryName === "carerinformation" &&
        itemKey === "template" &&
        currentSelectedItem.name === "Carer Information"
      )
        return true;
      else if (
        categoryName === "cancelappointments" &&
        itemKey === "template" &&
        currentSelectedItem.title === "Webform"
      )
        return true;
      return false;
    },

    initializeHeadingState(key, itemConfig) {
      if (!this.headingInternalStates[key]) {
        this.$set(this.headingInternalStates, key, { d_check_met: true });
      }
      this.updateHeadingDisplayStates(key, itemConfig);
    },
    updateHeadingDisplayStates(itemKey, itemConfig) {
      if (!this.headingInternalStates[itemKey]) {
        this.$set(this.headingInternalStates, itemKey, {});
      }
      const state = this.headingInternalStates[itemKey];
      const context = this.selectedItem || this.formData;
      let isMet = true;
      if (
        itemConfig.displayOn &&
        typeof itemConfig.displayOnValue !== "undefined"
      ) {
        isMet = false;
        const relevantValue =
          this.last_updated && this.last_updated.key === itemConfig.displayOn
            ? this.last_updated.value
            : context[itemConfig.displayOn];
        if (typeof relevantValue !== "undefined") {
          isMet = this._evaluateCondition(
            relevantValue,
            itemConfig.displayOnValue
          );
        }
      }
      this.$set(state, "d_check_met", isMet);
    },
    shouldHideHeading(itemKey, itemConfig) {
      const state = this.headingInternalStates[itemKey];
      if (!state) return true;
      if (
        itemConfig.displayOn &&
        typeof itemConfig.displayOnValue !== "undefined"
      ) {
        return !state.d_check_met;
      }
      return false;
    },
  },
  mounted() {
    if (this.formObject) {
      for (const key of Object.keys(this.formObject)) {
        const itemConfig = this.formObject[key];
        if (itemConfig?.type === "text") {
          this.initializeTextInputState(key, itemConfig);
        } else if (itemConfig?.type === "ckeditor") {
          this.initializeCKEditorState(key, itemConfig);
        } else if (itemConfig?.type === "select") {
          this.initializeSelectInputState(key, itemConfig);
        } else if (itemConfig?.type === "heading") {
          this.initializeHeadingState(key, itemConfig);
        }
      }
    }
  },
};
</script>

<template>
  <div class="banner-container">
    <template v-if="isEditable">
      <form
        v-if="formData && Object.keys(formObject).length"
        class="needs-validation banner-form-container"
        v-bind="$attrs"
        @submit.prevent="formSubmit"
      >
        <div class="row">
          <template v-for="(itemConfig, key) in formObject">
            <div
              v-if="displayLogic(itemConfig)"
              :key="key"
              class="form-group mb-0"
              :class="`col-${itemConfig.size || 12} ${itemConfig.class || ''}`"
            >
              <template v-if="itemConfig.type === 'text'">
                <div
                  class="text-input-wrapper mb-3"
                  :class="{ 'd-none': shouldHideTextInput(key, itemConfig) }"
                >
                  <Label
                    v-if="!itemConfig.hideLabel"
                    :item="{
                      ...itemConfig,
                      character_count: getTextInputMaxCharCount(
                        key,
                        itemConfig
                      ),
                    }"
                    :model_length="
                      formData[key] ? String(formData[key]).length : 0
                    "
                  />
                  <input
                    :value="formData[key]"
                    @input="handleInput(key, $event.target.value)"
                    :maxlength="getTextInputMaxCharCount(key, itemConfig)"
                    type="text"
                    class="form-control"
                    :class="{
                      'is-invalid':
                        submitted &&
                        $v.formData[key] &&
                        $v.formData[key].$error,
                      'bg-soft-secondary': isTextInputDisabled(key, itemConfig),
                    }"
                    :disabled="isTextInputDisabled(key, itemConfig)"
                    :placeholder="itemConfig.placeholder"
                  />
                  <div
                    v-if="
                      submitted && $v.formData[key] && $v.formData[key].$error
                    "
                    class="invalid-feedback"
                  >
                    <span v-if="$v.formData[key].required === false"
                      >This value is required.</span
                    >
                    <span v-else-if="$v.formData[key].maxLength === false"
                      >Exceeded max length.</span
                    >
                  </div>
                </div>
              </template>

              <template v-else-if="itemConfig.type === 'ckeditor'">
                <div
                  class="ckeditor-wrapper mb-3"
                  :class="{ 'd-none': shouldHideCKEditor(key, itemConfig) }"
                >
                  <Label
                    v-if="!itemConfig.hideLabel"
                    :item="{
                      ...itemConfig,
                      character_count: getTextInputMaxCharCount(
                        key,
                        itemConfig
                      ),
                    }"
                    :model_length="
                      formData[key] ? String(formData[key]).length : 0
                    "
                  />
                  <ckeditor
                    :editor="editor"
                    :value="formData[key]"
                    @input="(content) => handleInput(key, content)"
                    :config="getCKEditorConfig(key, itemConfig)"
                    :disabled="isCKEditorDisabled(key, itemConfig)"
                    :class="{ [key]: true }"
                  ></ckeditor>
                  <div
                    v-if="
                      submitted && $v.formData[key] && $v.formData[key].$error
                    "
                    class="invalid-feedback"
                  >
                    <span v-if="$v.formData[key].required === false"
                      >This value is required.</span
                    >
                  </div>
                </div>
              </template>

              <template v-else-if="itemConfig.type === 'select'">
                <div
                  v-if="shouldShowSelectBasedOnBanners(key, itemConfig)"
                  class="select-input-wrapper mb-3"
                  :class="{ 'd-none': shouldHideSelect(key, itemConfig) }"
                >
                  <Label
                    v-if="!itemConfig.hideLabel"
                    :item="{
                      ...itemConfig,
                      character_count: getTextInputMaxCharCount(
                        key,
                        itemConfig
                      ),
                    }"
                    :model_length="
                      formData[key] ? String(formData[key]).length : 0
                    "
                  />
                  <multiselect
                    :value="formData[key]"
                    @input="(newValue) => updateValue(key, newValue)"
                    :options="itemConfig.options"
                    :searchable="
                      itemConfig.searchable !== undefined
                        ? itemConfig.searchable
                        : false
                    "
                    :close-on-select="
                      itemConfig.closeOnSelect !== undefined
                        ? itemConfig.closeOnSelect
                        : true
                    "
                    :show-labels="
                      itemConfig.showLabels !== undefined
                        ? itemConfig.showLabels
                        : false
                    "
                    :allow-empty="
                      itemConfig.allowEmpty !== undefined
                        ? itemConfig.allowEmpty
                        : false
                    "
                    :placeholder="itemConfig.placeholder"
                    :disabled="isSelectDisabled(key, itemConfig)"
                    :class="{
                      'is-invalid':
                        submitted &&
                        $v.formData[key] &&
                        $v.formData[key].$error,
                    }"
                  ></multiselect>
                  <div
                    v-if="
                      submitted && $v.formData[key] && $v.formData[key].$error
                    "
                    class="invalid-feedback d-block"
                  >
                    <span v-if="$v.formData[key].required === false"
                      >This value is required.</span
                    >
                  </div>
                  <div
                    class="template-details"
                    v-if="showSelectTemplateDetails(key, itemConfig)"
                  >
                    <div
                      class="templatepurpose"
                      v-if="getSelectTemplatePurpose(key, itemConfig) !== ''"
                    >
                      <div class="purpose-label">{{ "Purpose" }}</div>
                      <div class="purpose-value">
                        {{ getSelectTemplatePurpose(key, itemConfig) }}
                      </div>
                      <div
                        class="descriptio-label"
                        v-if="
                          getSelectTemplateDescription(key, itemConfig) !== ''
                        "
                      >
                        {{ "Description" }}
                      </div>
                      <div
                        class="description-value"
                        v-if="
                          getSelectTemplateDescription(key, itemConfig) !== ''
                        "
                        v-html="getSelectTemplateDescription(key, itemConfig)"
                      ></div>
                    </div>
                  </div>
                </div>
              </template>

              <template v-else-if="itemConfig.type === 'heading'">
                <div
                  class="mb-3 heading-wrapper"
                  :class="{ 'd-none': shouldHideHeading(key, itemConfig) }"
                >
                  <h5 class="mt-2 mb-4 font-weight-semibold">
                    {{ itemConfig.label }}
                  </h5>
                </div>
              </template>

              <BannersPreview
                v-else-if="itemConfig.type === 'bannersPreview'"
                :item="itemConfig"
                :selectedItem="livePreviewData"
                :formFieldsData="formData"
                :theme="
                  formData[
                    Object.keys(formObject).find(
                      (k) => formObject[k].isThemeSelector === true
                    ) || 'theme'
                  ]
                "
                :isEditableBanner="
                  selectedItem && selectedItem.bannerType === 'editable'
                "
                :descriptionState="
                  ckEditorInternalStates.description ||
                  textInputInternalStates.description ||
                  {}
                "
                :quoteState="
                  ckEditorInternalStates.quote ||
                  textInputInternalStates.quote ||
                  {}
                "
                :last_updated="last_updated"
                :updateValue="updateValue"
              />
              <HR
                v-else-if="itemConfig.type == 'hr'"
                :item="itemConfig"
                :selectedItem="selectedItem || formData"
                :last_updated="last_updated"
              />
              <gutter
                v-else-if="itemConfig.type == 'gutter'"
                :item="itemConfig"
                :selectedItem="selectedItem || formData"
                :last_updated="last_updated"
              />
            </div>
          </template>
        </div>

        <button
          v-if="!topbarControls || !topbarControls.hideSaveButton"
          class="btn btn-primary mt-3 px-4 mb-5"
          type="submit"
          style="border-radius: 0"
        >
          SAVE
        </button>
      </form>
    </template>
    <template v-else>
      <BannersPreview
        :item="{ label: 'Banner Preview' }"
        :selectedItem="livePreviewData"
        :formFieldsData="formData"
        :theme="
          formData[
            Object.keys(formObject).find(
              (k) => formObject[k].isThemeSelector === true
            ) || 'theme'
          ]
        "
        :isEditableBanner="false"
        :descriptionState="
          ckEditorInternalStates.description ||
          textInputInternalStates.description ||
          {}
        "
        :quoteState="
          ckEditorInternalStates.quote || textInputInternalStates.quote || {}
        "
        :last_updated="last_updated"
        :updateValue="updateValue"
      />
    </template>
  </div>
</template>

<style scoped>
.banner-container {
  max-height: 700px;
  overflow: auto;
}
.form-group {
  margin-bottom: 1rem !important;
}
.text-input-wrapper {
}
.ckeditor-wrapper {
}
.ckeditor-wrapper .ck.ck-editor {
  border: 1px solid #ced4da;
  border-radius: 4px;
}

.select-input-wrapper .multiselect__select {
  z-index: 1;
}
.select-input-wrapper .purpose-label {
  padding-bottom: 10px;
  color: #333333;
  font-weight: 500;
}
.select-input-wrapper .descriptio-label {
  padding-top: 10px;
  padding-bottom: 10px;
  color: #333333;
  font-weight: 500;
}
.select-input-wrapper .templatepurpose {
  padding: 15px 0px;
}
.select-input-wrapper .purpose-value,
.select-input-wrapper .description-value {
  color: #65707b;
}
.select-input-wrapper .multiselect.is-invalid .multiselect__tags {
  border-color: #dc3545;
}
.invalid-feedback.d-block {
  display: block !important;
}

.heading-wrapper h5 {
}
</style>
